import { useDispatch } from 'react-redux';
import { Form, FormRenderProps } from 'react-final-form';
import { Dispatch } from 'redux';

import { Button } from 'UIPackage/MainModule/components/Button';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { Row } from 'UIPackage/FormModule/components/Row';
import { INpaEditorForm } from 'KnmPackage/RequirementsNpaModalModule/interfaces/INpaEditorForm';
import { TextInputField } from 'UIPackage/MainModule/components/TextInputField';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';
import { TextareaField } from 'UIPackage/MainModule/components/TextareaField';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { createNpaAction, editNpaAction } from 'KnmPackage/RequirementsNpaModalModule/actions/requirementsNpaActions';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IRequirementNpa } from 'APIPackage/RequirementsNpaModule/interfaces/IRequirementNpa';

import styles from './CreateEditNpaModal.module.scss';
import { NpaValidator } from './NpaValidator';

interface ICreateEditNpaModalProps {
  onClose: (newSuId?: string, newMandatoryId?: string, npaWasEdit?: boolean) => void;
  knoVersionId: string;
  supervisionVersionId: string;
  item?: IRequirementNpa;
}

export const CreateEditNpaModal = ({ onClose, knoVersionId, supervisionVersionId, item }: ICreateEditNpaModalProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const renderForm = ({ handleSubmit, values }: FormRenderProps<INpaEditorForm>) => {
    const isButtonDisabled = !values.dateAcceptance || !values.number || !values.title;

    return (
      <form onSubmit={handleSubmit}>
        <ModalHeader title={item ? 'Редактирование НПА' : 'Создание НПА'} />
        <div className={styles.Wrapper}>
          <Row notSpace>
            <FieldBlock
              label={
                <>
                  № НПА
                  <span className={styles.ReqIcon}>*</span>
                </>
              }
              size="col-4"
              margin="right"
            >
              <TextInputField name="number" />
            </FieldBlock>
            <FieldBlock
              label={
                <>
                  Дата утверждения акта<span className={styles.ReqIcon}>*</span>
                </>
              }
              size="col-4"
            >
              <DatePickerField name="dateAcceptance" maxDate={new Date()} />
            </FieldBlock>
          </Row>
          <Row>
            <FieldBlock
              label={
                <>
                  Наименование НПА<span className={styles.ReqIcon}>*</span>
                </>
              }
            >
              <TextareaField name="title" inputClassName={styles.NpaNameTextarea} resize="none" />
            </FieldBlock>
          </Row>
        </div>
        <ModalActions>
          <Button text="Сохранить" size="medium" color="primary" type="submit" disabled={isButtonDisabled} />
          <Button text="Отмена" size="medium" onClick={() => onClose()} />
        </ModalActions>
      </form>
    );
  };

  const handleSubmit = (values: INpaEditorForm) => {
    if (!item) {
      dispatch(
        createNpaAction(
          {
            number: values.number,
            title: values.title,
            acceptanceDate: formatDate({
              date: values.dateAcceptance ?? '',
              dateFormat: SYSTEM_DATE_FORMAT_FNS,
              parseFormat: DATE_FORMAT_LONG_FNS,
            }),
            oivControlId: knoVersionId,
            oivControlTypeId: supervisionVersionId,
          },
          [],
        ),
      );
      onClose();
    } else {
      dispatch(
        editNpaAction(
          {
            id: item?.id,
            number: values.number,
            title: values.title,
            acceptanceDate: formatDate({
              date: values.dateAcceptance ?? '',
              dateFormat: SYSTEM_DATE_FORMAT_FNS,
              parseFormat: DATE_FORMAT_LONG_FNS,
            }),
            oivControlId: knoVersionId,
            oivControlTypeId: supervisionVersionId,
          },
          [],
        ),
      );
      onClose(undefined, undefined, true);
    }
  };

  return (
    <>
      <Modal visible={true} onClose={onClose} modalBodyClassName={styles.Modal}>
        <Form<INpaEditorForm>
          render={renderForm}
          onSubmit={handleSubmit}
          validate={NpaValidator}
          initialValues={{
            title: item?.title,
            number: item?.number,
            dateAcceptance: formatDate({
              date: item?.acceptanceDate || '',
              dateFormat: DATE_FORMAT_LONG_FNS,
              parseFormat: SYSTEM_DATE_FORMAT_FNS,
            }),
          }}
        />
      </Modal>
    </>
  );
};
